<template>
  <div
    class='page-wrapper'
    :class='{hasSidebar: !$route.meta.hideNavigation}'
  >
    <Sidebar v-if='$route.meta.hideNavigation !== true'/>
    <MobileNavigation v-if='$route.meta.hideNavigation !== true'/>
    <MobileHeader v-if='$route.meta.hideNavigation !== true'/>

    <div class='page-content'>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Sidebar from "./blocks/Sidebar.vue";
import MobileNavigation from "./blocks/MobileNavigation.vue";
import MobileHeader from "./blocks/MobileHeader.vue";
import { onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";

export default {
  name: "App",
  components: {
    Sidebar,
    MobileNavigation,
    MobileHeader
  },
  data() {
    return {
      menuOpen: false,
    };
  },
  computed: {
    ...mapGetters("user", ["user", "loggedIn"]),
  },
  setup() {
    const router = useRouter();

    // Handle back button press
    const handleBackButton = (event) => {
      event.preventDefault();

      if (router.options.history.state.back) {
        router.back();
      } else {
        if (window.confirm("Do you want to exit the app?")) {
          navigator.app.exitApp();
        }
      }
    };

    // Add and remove event listeners
    onMounted(() => {
      document.addEventListener("backbutton", handleBackButton, false);
    });

    onUnmounted(() => {
      document.removeEventListener("backbutton", handleBackButton, false);
    });
  },
};
</script>



